import React from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_COLORS } from 'constants/colors';
import SvgIcon from 'ravenjs/lib/SvgIcon';

const UserSettingsIcon = ({ height, viewBox, width, color, colorInner, setRef, ...rest }) => (
    <SvgIcon {...rest} ref={setRef} width={width} height={height} viewBox={viewBox} fill="none">
        <path
            d="M9.66683 12L9.46683 11C9.3335 10.9445 9.2085 10.8861 9.09183 10.825C8.97516 10.7639 8.85572 10.6889 8.7335 10.6L7.76683 10.9L7.10016 9.76669L7.86683 9.10002C7.84461 8.94446 7.8335 8.80002 7.8335 8.66669C7.8335 8.53335 7.84461 8.38891 7.86683 8.23335L7.10016 7.56669L7.76683 6.43335L8.7335 6.73335C8.85572 6.64446 8.97516 6.56946 9.09183 6.50835C9.2085 6.44724 9.3335 6.38891 9.46683 6.33335L9.66683 5.33335H11.0002L11.2002 6.33335C11.3335 6.38891 11.4585 6.45002 11.5752 6.51669C11.6918 6.58335 11.8113 6.66669 11.9335 6.76669L12.9002 6.43335L13.5668 7.60002L12.8002 8.26669C12.8224 8.40002 12.8335 8.53891 12.8335 8.68335C12.8335 8.8278 12.8224 8.96669 12.8002 9.10002L13.5668 9.76669L12.9002 10.9L11.9335 10.6C11.8113 10.6889 11.6918 10.7639 11.5752 10.825C11.4585 10.8861 11.3335 10.9445 11.2002 11L11.0002 12H9.66683ZM0.333496 11.3334V9.46669C0.333496 9.10002 0.427941 8.75558 0.616829 8.43335C0.805718 8.11113 1.06683 7.86669 1.40016 7.70002C1.96683 7.41113 2.60572 7.16669 3.31683 6.96669C4.02794 6.76669 4.81127 6.66669 5.66683 6.66669H5.90016C5.96683 6.66669 6.0335 6.6778 6.10016 6.70002C5.77794 7.50002 5.64461 8.29446 5.70016 9.08335C5.75572 9.87224 6.02239 10.6222 6.50016 11.3334H0.333496ZM10.3335 10C10.7002 10 11.0141 9.86946 11.2752 9.60835C11.5363 9.34724 11.6668 9.03335 11.6668 8.66669C11.6668 8.30002 11.5363 7.98613 11.2752 7.72502C11.0141 7.46391 10.7002 7.33335 10.3335 7.33335C9.96683 7.33335 9.65294 7.46391 9.39183 7.72502C9.13072 7.98613 9.00016 8.30002 9.00016 8.66669C9.00016 9.03335 9.13072 9.34724 9.39183 9.60835C9.65294 9.86946 9.96683 10 10.3335 10ZM5.66683 6.00002C4.9335 6.00002 4.30572 5.73891 3.7835 5.21669C3.26127 4.69446 3.00016 4.06669 3.00016 3.33335C3.00016 2.60002 3.26127 1.97224 3.7835 1.45002C4.30572 0.927798 4.9335 0.666687 5.66683 0.666687C6.40016 0.666687 7.02794 0.927798 7.55016 1.45002C8.07239 1.97224 8.3335 2.60002 8.3335 3.33335C8.3335 4.06669 8.07239 4.69446 7.55016 5.21669C7.02794 5.73891 6.40016 6.00002 5.66683 6.00002Z"
            fill={color}
        />
    </SvgIcon>
);

UserSettingsIcon.propTypes = {
    color: PropTypes.string,
    colorInner: PropTypes.string,
    height: PropTypes.string,
    setRef: PropTypes.object,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

UserSettingsIcon.defaultProps = {
    color: DEFAULT_COLORS.BLUE_6,
    colorInner: DEFAULT_COLORS.BLACK,
    height: '16',
    setRef: null,
    viewBox: '0 0 13.23 11.33',
    width: '16',
};

export default UserSettingsIcon;
